import { Component, OnInit, HostListener, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { AuthService } from '../../auth.service';
import { AwardsService } from '../../awards.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit {
  @Input() tooltipText: string;
  @Input() top: string = '10';
  @Input() right: string = '0';

  constructor() {}

  ngOnInit() {}
}
